import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigProvider } from 'src/app/service/config.service';
import { TravelService } from 'src/app/service/travel.service';
import { PaymentConfig } from 'src/app/shared/insurance.model';

type FormValidatorFunction = (...args) => boolean;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json-patch+json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class StepService {

  private readonly config: PaymentConfig;
  public beneficiary = true;
  public children = true;
  readonly API_SERVER = "https://platformapi.aldagi.ge";

  private stepSource: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  currentStep = this.stepSource.asObservable();
  private _stepValidator: FormValidatorFunction;
  private _steps: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  toggle: BehaviorSubject<boolean> = new BehaviorSubject(false);
  toggle$ = this.toggle.asObservable();

  constructor(private http: HttpClient, private travelService: TravelService, configProvider: ConfigProvider) {
    this._stepValidator = () => true;
    this.config = configProvider.getConfig() as PaymentConfig;
  }


  sendCreateApplicationRequest(data): Observable<any> {

    Date.prototype.toJSON = function() { return moment(this).format('YYYY-MM-DDTHH:mm:ss'); };

    return this.http.post(this.API_SERVER + '/api/PolicyApplications/for-travel', data, httpOptions);
  }

  changeStep(step: number) {
    this.stepSource.next(step);
  }

  set stepValidator(validator: FormValidatorFunction) {
    this._stepValidator = validator;
  }

  get stepValidator(): FormValidatorFunction {
    return this._stepValidator;
  }

  set steps(steps: any[]) {
    this._steps.next(steps);
  }

  get steps(): any[] {
    return this._steps.getValue();
  }

  get stepsAsync(): BehaviorSubject<any[]> {
    return this._steps;
  }

  nextStep() {
    if (this.stepSource.getValue() < this.steps.length) {
      if (this.stepSource.getValue() + 1 == this.steps.length){
        let request = this.travelService.cookCreateApplicationRequest();
        this.sendCreateApplicationRequest(request).subscribe(
          data =>   {
            this.travelService.createApplicationResponse = data;
          
            this.travelService.sendPaymentRequest(this.config);
                
          }
        );
      } else {
      this.stepSource.next(this.stepSource.getValue() + 1);
      this._stepValidator = () => true;

      }

    }
  }

  prevStep() {
    if (this.stepSource.getValue() <= this.steps.length) {
      this.stepSource.next(this.stepSource.getValue() - 1);
    }
  }
}
